import { createFileRoute } from '@tanstack/react-router'
import { CalendarPage } from '@/pages/Calendar'

export const Route = createFileRoute('/_authenticated/calendar')({
  /**
   * `focus` is an entry id to open on arrival (#1343). A participant
   * notification has to land on the activity itself, not just the month it
   * falls in, and the calendar had no way to address one until now.
   *
   * Mirrors the feedback route's `focus` param so both notification kinds
   * deep-link the same way.
   */
  validateSearch: (s: Record<string, unknown>): { focus?: string } => ({
    focus: typeof s.focus === 'string' ? s.focus : undefined,
  }),
  component: CalendarRoute,
})

/**
 * Reading the search param here rather than inside CalendarPage keeps the page
 * renderable without a router — `useSearch` throws outside one, where
 * `useNavigate` only warns.
 */
function CalendarRoute() {
  const { focus } = Route.useSearch()
  return <CalendarPage focusEntryId={focus} />
}
